// extracted by mini-css-extract-plugin
export default {"bottom":"Vi88Uv5hhbJTVOpLa2gN","spin":"eM1t0O4q62sk9M_StvbE"};